<template>
    <div class="row mx-lg-auto">
        <div class="col-md-6 mx-lg-auto ">
        <div class="input-card mx-lg-auto" @mouseleave="ValidarRespuesta">
            <div class="input-card-form">
              <div class="row">
                <div class="col-md-3 mx-lg-auto ">
                  <div class="input-card-form" id="diaFecha">
                    <!-- Select -->
                    <select class="form-select" v-model="fecha.day" @change="ValidarRespuesta">
                      <option v-for="(dia, indexDay) in dias" :key="indexDay" :value="dia">{{dia}}</option>
                    </select>
                    <!-- End Select -->
                  </div>
                </div>
                <div class="col-md-5 mx-lg-auto ">
                  <div class="input-card-form" id="mesFecha">
                    <!-- Select -->
                    <select class="form-select" v-model="fecha.month" @change="ValidarRespuesta">
                      <option v-for="(mes, indexMonth) in meses" :key="indexMonth" :value="mes">{{mes}}</option>
                    </select>
                    <!-- End Select -->
                  </div>
                </div>

                <div class="col-md-4 mx-lg-auto ">
                  <div class="input-card-form" id="anioFecha">
                    <!-- Select -->
                    <select class="form-select" v-model="fecha.year" @change="ValidarRespuesta">
                      <option v-for="(anio, indexYear) in anios" :key="indexYear" :value="anio">{{anio}}</option>
                    </select>
                    <!-- End Select -->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
    </div>
</template>

<script>

import FuncionesFechas from './Fecha/FuncionesDeFecha.js'

export default {
  name: 'Fecha',
  props: {

    response: String,
    FormularioTag: String,
    idQuestion: Number,
    minDate: String,
    maxDate: String
  },

  data: function(){

    return {

        fecha: {

          day : null,
          month : null,
          year: null

        },

        dias: [],

        meses: [
          "Enero", 
          "Febrero",
          "Marzo",
          "Abril",
          "Mayo",
          "Junio",
          "Julio",
          "Agosto",
          "Septiembre",
          "Octubre",
          "Noviembre", 
          "Diciembre"
        ],

        anios: []


    }


  },

  mounted(){

    if (this.response != null)
    {

      this.fecha = FuncionesFechas.pintarFecha(this.response);

    } else {

      this.fecha = FuncionesFechas.pintarFecha(this.minDate);

    }

    this.dias = FuncionesFechas.DatosDias(this.fecha.month, this.fecha.year);
    this.anios = FuncionesFechas.CalcularMatrizAnios(this.minDate, this.maxDate);


    this.$watch('fecha.month', function () {
        
        let mes = this.fecha.month;
        let anio = this.fecha.year;

        this.dias = FuncionesFechas.DatosDias(mes, anio);

    });

    this.$watch('fecha.year', function () {
        
        let mes = this.fecha.month;
        let anio = this.fecha.year;

        this.dias = FuncionesFechas.DatosDias(mes, anio);
       

    });

  },

  methods: {

      ValidarRespuesta : function(){

        let valido = FuncionesFechas.validarFecha(this.minDate, this.maxDate, this.fecha);


        if (valido == true)
        {

            let Mutation = {

                formulario: this.FormularioTag,
                question: this.idQuestion,
                validate: true,
                response: FuncionesFechas.guardarFecha(this.fecha)
            };

            
            this.$store.commit('actualizarRespuestaFormulario', Mutation);    

        } else {

            let Mutation = {

                formulario: this.FormularioTag,
                question: this.idQuestion,
                validate: false,
                response: FuncionesFechas.guardarFecha(this.fecha)

            };

            this.$store.commit('actualizarRespuestaFormulario', Mutation);    

        }

      }


  }
}
</script>

<style scoped>
@media only screen and (max-width: 768px) {
  .input-card-form {
    padding:15px;
    text-align: center;
  }
  .form-select {
    text-align: center;
  }
}


</style>